(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rhm-contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('contact-dialog');
    if (!dialog || dialog.dataset.rhmBound === 'true') return;
    dialog.dataset.rhmBound = 'true';
    const sheet = dialog.querySelector('.rhm-contact-modal__sheet');
    const form = dialog.querySelector('#ContactForm');
    const errorEl = dialog.querySelector('.rhm-form__status--error');
    const successEl = dialog.querySelector('.rhm-form__status--success');
    const submitBtn = form?.querySelector('button[type="submit"]');
    const CONTACT_URL = 'https://api.robotshatemonkeys.com/api/contact';
    const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const open = () => {
      if (!dialog.open) dialog.showModal();
      requestAnimationFrame(() => {
        requestAnimationFrame(() => sheet?.classList.add('is-shown'));
      });
      dialog.querySelector('#contact-name')?.focus({ preventScroll: true });
    };

    const close = () => {
      sheet?.classList.remove('is-shown');
      const finish = () => {
        if (dialog.open) dialog.close();
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else window.setTimeout(finish, 560);
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-contact-open]');
      if (trigger) {
        event.preventDefault();
        open();
        return;
      }
      if (event.target.closest('[data-contact-close]')) {
        event.preventDefault();
        close();
      }
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form || form.dataset.submitting === 'true') return;

      const data = {
        name: form.querySelector('#contact-name')?.value.trim() || '',
        email: form.querySelector('#contact-email')?.value.trim() || '',
        company: form.querySelector('#contact-company')?.value.trim() || '',
        message: form.querySelector('#contact-message')?.value.trim() || '',
        website: form.querySelector('#contact-website')?.value || '',
      };

      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      if (successEl) successEl.hidden = true;

      if (!data.name || !data.email || !data.company) {
        if (errorEl) {
          errorEl.textContent = 'Please fill in name, email, and company.';
          errorEl.hidden = false;
        }
        return;
      }

      if (!EMAIL_PATTERN.test(data.email)) {
        if (errorEl) {
          errorEl.textContent = 'Please enter a valid email address.';
          errorEl.hidden = false;
        }
        return;
      }

      form.dataset.submitting = 'true';
      if (submitBtn) submitBtn.disabled = true;

      try {
        const response = await fetch(CONTACT_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        });
        const payload = await response.json().catch(() => null);
        if (!response.ok || !payload?.ok) {
          if (errorEl) {
            errorEl.textContent = payload?.error || 'Could not send the message. Try again later.';
            errorEl.hidden = false;
          }
          return;
        }
        if (successEl) successEl.hidden = false;
        form.reset();
      } catch {
        if (errorEl) {
          errorEl.textContent = 'Could not send the message. Try again later.';
          errorEl.hidden = false;
        }
      } finally {
        form.dataset.submitting = 'false';
        if (submitBtn) submitBtn.disabled = false;
      }
    });

    if (location.hash === '#contact') open();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rhm-header"] && !Shopify.designMode) return;
  try {
    (() => {
    const label = document.querySelector('[data-header-label]');
    const nodes = document.querySelectorAll('[data-section-label]');
    if (!label || !nodes.length || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        const next = visible.target.getAttribute('data-section-label');
        if (next) label.textContent = next;
      },
      { rootMargin: '-45% 0px -45% 0px', threshold: [0, 0.25, 0.5] }
    );
    nodes.forEach((node) => observer.observe(node));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rhm-project-line"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktop = () => window.matchMedia('(min-width: 760px)').matches;

    const setExpanded = (article, expanded) => {
      const panel = article.querySelector('.rhm-project-line__panel');
      const button = article.querySelector('.rhm-project-line__button');
      if (!panel || !button) return;
      panel.classList.toggle('is-open', expanded);
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
      if (expanded) panel.removeAttribute('inert');
      else panel.setAttribute('inert', '');
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.rhm-project-line__button');
      if (!button) return;
      const article = button.closest('.rhm-project-line');
      if (!article) return;
      const hasDetail = article.hasAttribute('data-has-detail');
      if (desktop() && !hasDetail) return;
      const panel = article.querySelector('.rhm-project-line__panel');
      if (!panel) return;
      const willOpen = !panel.classList.contains('is-open');
      const list = article.parentElement;
      list?.querySelectorAll('.rhm-project-line').forEach((row) => setExpanded(row, false));
      if (willOpen) setExpanded(article, true);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
